<template>
  <section class="pagination">
    <!-- 功能：上一頁 -->
    <button
      :class="[
        'pagination__change-page',
        'previous-page',
        { 'pagination__change-page--disabled': isFirstPage },
      ]"
      :disabled="isFirstPage"
      :aria-disabled="isFirstPage"
      title="前往上一頁"
      @click="
        $emit('update:getUpdatedArticles', {
          category: category,
          page: pages.current_page - 1,
        })
      "
      @keypress="
        $emit('update:getUpdatedArticles', {
          category: category,
          page: pages.current_page - 1,
        })
      "
      >上一頁</button
    >

    <!-- 頁數區 -->
    <nav aria-label="頁數切換區">
      <ul class="pagination__pages">
        <!-- <li v-for="(page, pageIndex) in pages.last_page" :key="pageIndex">
          <span class="u-hidden">第</span>
          <button
            :class="['pagination__page', {'pagination__page--now': getIsCurrentPage(page)}]"
            :disabled="getIsCurrentPage(page)"
            :aria-disabled="getIsCurrentPage(page)"
            :aria-current="getIsCurrentPage(page)"
            @click="$emit('update:getUpdatedArticles', {
              category: category,
              page: page })"
            @keypress="$emit('update:getUpdatedArticles', {
              category: category,
              page: page })"
          >{{ page }}</button>
          <span class="u-hidden">頁</span>
        </li> -->
        <li v-for="(item, index) in pagination" :key="index">
          <span class="u-hidden">第</span>
          <button
            :title="`第${item.value}頁`"
            :class="[
              'pagination__page',
              { 'pagination__page--now': getIsCurrentPage(item.value) },
            ]"
            :disabled="getIsCurrentPage(item.value)"
            :aria-disabled="getIsCurrentPage(item.value)"
            :aria-current="getIsCurrentPage(item.value)"
            @click="item._handleClick"
            @keypress="item._handleClick"
            >{{ item.value }}</button
          >
          <span class="u-hidden">頁</span>
        </li>
      </ul>
    </nav>

    <!-- 功能：下一頁 -->
    <button
      :class="[
        'pagination__change-page',
        'next-page',
        { 'pagination__change-page--disabled': isLastPage },
      ]"
      :disabled="isLastPage"
      :aria-disabled="isLastPage"
      title="前往下一頁"
      @click="
        $emit('update:getUpdatedArticles', {
          category: category,
          page: pages.current_page + 1,
        })
      "
      @keypress="
        $emit('update:getUpdatedArticles', {
          category: category,
          page: pages.current_page + 1,
        })
      "
      >下一頁</button
    >
  </section>
</template>

<script>
export default {
  name: 'TheListPagination',
  props: {
    pages: {
      type: Object,
      default: () => ({
        current_page: 1,
      }),
      required: true,
    },
    category: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isFirstPage() {
      return this.pages.current_page === 1;
    },
    isLastPage() {
      return this.pages.current_page === this.pages.last_page;
    },
    pagination() {
      const { current_page, last_page } = this.pages;
      const pagantion = [];
      const thePrevPage = current_page - 2 >= 1 ? current_page - 2 : 1;
      const theNextPage =
        current_page + 2 >= last_page ? last_page : current_page + 2;

      if (last_page <= 5) {
        for (let page = 1; page <= last_page; page++) {
          pagantion.push(this.getPage(page));
        }
        return pagantion;
      }
      if (current_page - 5 >= 1) {
        pagantion.push(this.getPage(current_page - 5, '...'));
      }

      if (thePrevPage === 1) {
        for (let page = 1; page <= 5; page++) {
          pagantion.push(this.getPage(page));
        }
      } else if (theNextPage === last_page) {
        for (let page = theNextPage - 4; page <= theNextPage; page++) {
          pagantion.push(this.getPage(page));
        }
      } else {
        for (let page = thePrevPage; page <= theNextPage; page++) {
          pagantion.push(this.getPage(page));
        }
      }

      if (current_page + 5 <= last_page) {
        pagantion.push(this.getPage(current_page + 5, '...'));
      }
      return pagantion;
    },
  },
  methods: {
    getIsCurrentPage(currentPage) {
      return this.pages.current_page === currentPage;
    },
    getPage(page, value) {
      return {
        _handleClick: () => {
          this.$emit('update:getUpdatedArticles', {
            category: this.$props.category,
            page,
          });
        },
        value: value || page,
      };
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 40px;

  @include for-tablet {
    margin-top: 0;
  }

  &__change-page {
    position: relative;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: transparent;
    border: 0;
    color: $color-light-text;
    cursor: pointer;
    user-select: none;

    &:hover {
      color: lighten($color-light-text, 10);

      &::before,
      &::after {
        background-color: lighten($color-light-text, 10);
      }
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 10px;
      height: 2px;
      background-color: $color-light-text;
      border-radius: 5px;
    }

    &::before {
      top: 22px;
    }

    &::after {
      top: 15px;
    }

    &--disabled {
      color: rgba($color-light-text, 0.5);
      cursor: no-drop;

      &:hover {
        color: rgba($color-light-text, 0.5);

        &::before,
        &::after {
          background-color: rgba($color-light-text, 0.5);
        }
      }

      &::before,
      &::after {
        background-color: rgba($color-light-text, 0.5);
      }
    }
  }

  .previous-page {
    padding-left: 20px;

    &::before,
    &::after {
      left: 5px;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }

  .next-page {
    padding-right: 20px;

    &::before,
    &::after {
      right: 5px;
    }

    &::before {
      top: 22px;
      transform: rotate(-45deg);
    }

    &::after {
      top: 16px;
      transform: rotate(45deg);
    }
  }

  nav {
    // for a11y structure
    display: inline;
  }

  &__pages {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    max-width: 90%;
    list-style: none;
    padding: 0;
    margin: 0 10px;
  }

  &__page {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    padding: 0 5px;
    border: 0;
    background-color: transparent;
    color: $color-light-text;
    cursor: pointer;

    &:hover {
      color: lighten($color-light-text, 10);
    }

    &--now {
      border-radius: 50%;
      background-color: $color-light-text;
      color: $color-tag-text;
      cursor: no-drop;

      &:hover {
        color: $color-tag-text;
      }
    }
  }

  &__page + &__page {
    margin-left: 5px;
  }
}
</style>
